module.exports = __webpack_public_path__ + "static/media/plus-red.9e4a5410.svg";